<template>
  <div class="tm-captcha">
    <vue-recaptcha
      :sitekey="siteKey"
      :class="{ 'tm-captcha--hidden': !captchaReady }"
      load-recaptcha-script
      @verify="handleCaptchaPassed"
      @render="handleCaptchaReady"
    />
    <div class="tm-captcha__loader-spinner">
      <tm-spinner
        v-if="!captchaReady"
        color="primary"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { VueRecaptcha } from 'vue-recaptcha'
import { defineComponent, ref } from '@/composition/vue/compositionApi'
import TmSpinner from '@/components/shared/TmSpinner.vue'

export default defineComponent({
  components: {
    TmSpinner,
    VueRecaptcha,
  },
  emits: {
    passed: (_: string) => true,
  },
  setup(props, context) {
    const captchaReady = ref(false)

    const handleCaptchaReady = () => {
      captchaReady.value = true
    }

    const handleCaptchaPassed = async (responseCode: string) => {
      captchaReady.value = false

      context.emit('passed', responseCode)
    }

    return {
      siteKey: import.meta.env.VUE_APP_RECAPTCHA_SITE_KEY as string,
      handleCaptchaReady,
      handleCaptchaPassed,
      captchaReady,
    }
  },
})
</script>

<style lang="scss" scoped>
.tm-captcha {
  display: flex;
  justify-content: center;
  margin-top: 16px;

  &--hidden {
    display: none;
  }

  &__loader-spinner {
    height: 78px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
